module.exports = __webpack_public_path__ + "img/bg8.dcb72ecc.png";